import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
export { TranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
  imports: [
      CommonModule,
      HttpClientModule,
      TranslateModule
    ],
    exports: [CommonModule, TranslateModule],
    declarations: []
})

export class BrandModule { }
